import { Header } from 'components/Header';
import { SignUpForm } from 'components/Forms';
import { Footer } from 'components/Footer';

export function Registration() {
  return (
    <>
      <Header />
      <SignUpForm />
      <Footer />
    </>
  );
}
